// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"resumePowerConfirmPopUp__gradient-bg5__Jp7TP","resumePopup":"resumePowerConfirmPopUp__resumePopup__onMjW"};